export enum enumActivityItem {
  CREATED,
  UPDATED,
  DELETED,
  PREVIOUS,
  NOT_MODIFIED,
}
